
import React from 'react';
interface ErrorMessageProps {
    text: string;
    header: string;
    id: string;
}

const ErrorMessage = (props: ErrorMessageProps) => {
    return <div>{props.text}</div>;
};

export default ErrorMessage;
